import { jsx as _jsx } from "react/jsx-runtime";
export const Number = (props) => {
    return (_jsx("input", { type: "number", size: 6, value: props.value, onChange: e => props.setValue(parseInt(e.target.value)) }));
};
